import { render, staticRenderFns } from "./transactions.vue?vue&type=template&id=56f32d8e"
import script from "./transactions.js?vue&type=script&lang=js&external"
export * from "./transactions.js?vue&type=script&lang=js&external"
import style0 from "./transactions.vue?vue&type=style&index=0&id=56f32d8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports